import {
    $, addAction, INIT, LAYOUT, SCROLL,
} from '@situation/setdesign.util';

addAction(INIT, () => {
    const $stickyHeader = $('.header-nav');
    const $buyTickets = $('.event-single-sidebar__buy-tickets');
    const $stickyContainer = $('.sticky-buy-tickets__container');
    const $stickyBuyTickets = $stickyContainer.find('.sticky-buy-tickets');
    if (!$buyTickets.length) {
        return;
    }

    let stickyButtonHeight;
    let viewportHeight;
    let stickyHeaderHeight;
    let isContainerActive;
    addAction(LAYOUT, () => {
        stickyHeaderHeight = $stickyHeader.outerHeight();
        stickyButtonHeight = $stickyBuyTickets.outerHeight();
        viewportHeight = SetDesign.viewport.height();
        isContainerActive = $stickyContainer.is(':visible');
    });

    addAction(SCROLL, () => {
        if (!isContainerActive) {
            return;
        }

        const lowerBound = $stickyContainer[0].getBoundingClientRect().top + stickyButtonHeight;
        const upperBound = $buyTickets[0].getBoundingClientRect().bottom - stickyHeaderHeight;
        $stickyBuyTickets.toggleClass('sticky-buy-tickets--float', upperBound <= 0);
        $stickyBuyTickets.toggleClass('sticky-buy-tickets--stick', upperBound <= 0 && lowerBound < viewportHeight);
    });
});
